import React, { useEffect, useRef } from 'react';
import { PanoramaDetails } from '../services/UploadManagementServiceTypes';
import { AAssets, ACamera, ACursor, AImage, AScene, ASky } from './AframeItems';
import type { ACameraElement } from './AframeTypes';
import { IndexedPanorama } from './useGalleryNavigation';

const getPosition = (panoramaDetails: PanoramaDetails): string => `${0} ${0} ${0}`;

export interface PanoramaViewerProps {
  currentPanoramaIndex: number;
  currentPanorama: PanoramaDetails;
  panoramas: PanoramaDetails[];
  resetCameraRotation: (camera: ACameraElement) => void;
}

const getHtmlId = ({ index, panorama }: IndexedPanorama) => panorama.panoramaGuid + index;

export const PanoramaViewer: React.FC<PanoramaViewerProps> = ({
  currentPanorama,
  currentPanoramaIndex,
  panoramas,
  resetCameraRotation,
  children,
}) => {
  const cameraRef = useRef<any>(null);
  useEffect(() => {
    const camera = cameraRef.current;
    if (!camera) {
      return;
    }
    resetCameraRotation(camera);
  }, [currentPanorama, cameraRef, resetCameraRotation]);
  return (
    <AScene>
      <AAssets>
        {panoramas.map((p, index) => {
          const id = getHtmlId({ panorama: p, index });
          return <AImage key={id} id={id} src={p.imageDownloadUrl} />;
        })}
      </AAssets>
      <ASky src={`#${getHtmlId({ panorama: currentPanorama, index: currentPanoramaIndex })}`} />

      {children}

      <ACamera ref={cameraRef} position={getPosition(currentPanorama)}>
        <ACursor />
      </ACamera>
    </AScene>
  );
};
